import { computed } from '@vue/composition-api';
import { useRoute, useRouter } from '@/utils/hooks';

export default function useQueryValue(
	queryName,
	{ defaultValue, get, set, isArray = false, isNumber = false, replace = false } = {}
) {
	const route = useRoute();
	const router = useRouter();

	const replaceQuery = query => {
		const newQuery = { query: { ...route.value.query, ...query } };
		replace ? router.replace(newQuery) : router.push(newQuery);
	};

	if (isArray) {
		return computed({
			get:
				get ||
				(() => {
					const queryString = route.value.query?.[queryName] || '';
					if (!queryString) return defaultValue || [];

					if (isNumber) {
						return (String(queryString).split?.(',').filter(Boolean) || []).map(Number);
					}
					return String(queryString).split?.(',').filter(Boolean) || [];
				}),
			set: set || (value => replaceQuery({ [queryName]: value.join() })),
		});
	}

	return computed({
		get:
			get ||
			(() => {
				const queryString = route.value.query?.[queryName] || '';
				if (!queryString) return defaultValue;

				if (isNumber) {
					const value = Number(queryString);
					return Number.isNaN(value) ? undefined : value;
				}
				return queryString || undefined;
			}),
		set: set || (value => replaceQuery({ [queryName]: value })),
	});
}
